import React, { Component } from "react";
import {
  Tab,
  Card,
  CardColumns,
  Container,
  Row,
  Col,
  ListGroup,
} from "react-bootstrap";
import { connect } from "react-redux";

import {
  GetPeppHierarchy,
  GetMasterClusters,
  GetBranchByCode,
} from "../../store/actions/crdm_service_actions";

import AsyncSelect from "react-select/async";

import { Tabs } from "react-bootstrap";
import { Badge } from "react-bootstrap";

import { check } from "../../images";

import CardLoader from "../../components/extensions/CardLoader";

class PeppOperationSelector extends Component {
  state = {
    branches: [],
    heirarchy: [],
    isLoading: false,
    viewBy: "Cluster",
    cluster_check_list: [],
    area_check_list: [],
    lastSelectedClusterIndex: 0,
    lastSelected: {
      branchesByArea: [],
    },
    isOverall: false,
  };

  componentDidMount() {
    this.startLoading();
    this.appendItemData();
    this.endLoading();
  }

  getAreaCheckedState = (idx) => {
    try {
      let { area_check_list } = this.state;
      let selected = area_check_list[idx];
      let value = selected.value;
      return value;
    } catch {
      return false;
    }
  };

  getClusterCheckedState = (idx) => {
    let { cluster_check_list } = this.state;
    let selected = cluster_check_list[idx];
    let value = selected.value;
    return value;
  };

  getSelectedAreaCheckList = () => {
    let { area_check_list, isOverall } = this.state;
    let selectedList = area_check_list
      .filter((x) => x.value === true)
      .map((d) => d.name);

    if (selectedList.length > 0 && isOverall === false) {
      return (
        <span className="d-inline bold">
          Selected <p className="text-danger">{selectedList.join()}</p>
        </span>
      );
    } else {
      return "No Area Selected";
    }
  };

  getSelectedClusterCheckList = () => {
    let { cluster_check_list } = this.state;
    let selectedList = cluster_check_list
      .filter((x) => x.value === true)
      .map((d) => d.name);

    if (selectedList.length > 0) {
      return (
        <span className="d-inline bold">
          Selected <p className="text-danger">{selectedList.join()}</p>
        </span>
      );
    } else {
      return "No Cluster Selected";
    }
  };

  isAreaSingleChecked = (idx = null, data) => {
    if (idx !== null) {
      let { area_check_list, isOverall } = this.state;

      if (!isOverall) {
        let new_area_check_list = area_check_list.slice();

        if (this.props.isAreaMultiSelect === false) {
          area_check_list.forEach((item) => (item.value = false));
          this.setState({ area_check_list: area_check_list });
        }

        let newValue = !new_area_check_list[idx].value;
        new_area_check_list[idx].value = newValue;

        this.setState({
          area_check_list: this.state.lastSelected.branchesByArea,
        });

        var item = [
          {
            area_code: data.areaCode,
            name: data.areaName,
            key: idx,
            value: true,
            branchCodes: data.peppBranches.map((d) => d.branchCode),
          },
        ];

        this.props.onAreaChanged(item);
      }
      this.forceUpdate();
    }
  };

  isClusterSingleChecked = (idx = null) => {
    if (idx !== null) {
      let { cluster_check_list, heirarchy, isOverall } = this.state;

      if (!isOverall) {
        let new_cluster_check_list = cluster_check_list.slice();

        if (this.props.isClusterMultiSelect === false) {
          new_cluster_check_list.forEach((item) => (item.value = false));
          this.setState({ cluster_check_list: new_cluster_check_list });
        }

        let newValue = !new_cluster_check_list[idx].value;
        new_cluster_check_list[idx].value = newValue;

        this.setState({
          lastSelectedClusterIndex: idx,
          cluster_check_list: new_cluster_check_list,
          lastSelected: heirarchy[idx],
        });

        var checked = new_cluster_check_list.filter((x) => x.value === true);
        this.props.onClusterChanged(checked);
      }
    }
  };

  startLoading = () => {
    this.setState({ isLoading: true });
  };
  endLoading = () => {
    this.setState({ isLoading: false });
  };

  appendItemData = () => {
    this.premiseGetMasterClusters().then((resp) => {
      let { master_cluster } = this.props;
      let cluster_id_list = master_cluster.map((d) => d.id);

      let cluster_check_list = master_cluster.map((d, idx) => {
        return { id: d.id, name: d.name, key: idx, value: false };
      });

      this.premiseGetPeppHeirarchy({
        cluster_ids: cluster_id_list,
      }).then((r) => {
        if (r.problem === null) {
          if (r.data.length > 0) {
            let area_check_list = r.data[0].branchesByArea.map((d, idx) => {
              return {
                id: idx,
                area_code: d.areaCode,
                name: d.areaName,
                key: idx,
                value: false,
              };
            });

            this.setState({
              lastSelected: r.data[0],
              heirarchy: r.data,
              cluster_check_list: cluster_check_list,
              area_check_list: area_check_list,
            });
          }
        }
      });
    });
  };

  loadOptions = (inputValue, callback) => {
    // do some work

    if (inputValue.length >= 3) {
      this.PremiseGetBranchByCode(inputValue).then((resp) => {
        if (resp.problem === null) {
          if (resp.data && resp.data.length > 0) {
            const currentItem = resp.data[0];
            return callback([
              {
                label: `(${currentItem.branchCode}) ${currentItem.branchName}`,
                value: currentItem.branchCode,
              },
            ]);
          }

          return callback([]);
        }

        return callback([]);
      });
    } else {
      return callback([]);
    }
  };

  handlebranchCode = (fieldData) => {
    this.setState({ branches: fieldData });
    this.props.onSelectedBranchChanged(fieldData);
  };

  renderByCluster = () => {
    return (
      <Container>
        <Row>
          <Col>
            <CardColumns className="p-3 m-2">
              {this.state.heirarchy.map((data, idx) => {
                return (
                  <Card
                    className="w-100"
                    hidden={data.branchesByArea.length <= 0}
                    border={
                      this.getClusterCheckedState(idx) === true ? "success" : ""
                    }
                    key={idx}
                    onClick={() => {
                      this.isClusterSingleChecked(idx);
                    }}
                  >
                    <Card.Body>
                      <Card.Title>
                        {data.clusterName}
                        <span
                          className="float-right"
                          hidden={!this.getClusterCheckedState(idx)}
                        >
                          <img height={25} alt="selected" src={check} />
                        </span>
                      </Card.Title>
                      <Card.Subtitle>
                        <Badge variant="dark">{data.clusterCode}</Badge>
                      </Card.Subtitle>

                      <Card.Text>
                        <small className="text-muted">{`${
                          data.branchesByArea.length > 0
                            ? data.branchesByArea.length
                            : "No"
                        } Areas`}</small>
                      </Card.Text>
                    </Card.Body>
                  </Card>
                );
              })}
            </CardColumns>
          </Col>
        </Row>
        <Row>
          <Col>{/* <p>{this.getSelectedClusterCheckList()}</p> */}</Col>
        </Row>
      </Container>
    );
  };

  renderByArea = () => {
    return (
      <Container className="p-3 m-2" fluid>
        <Row>
          <Col xl={4}>
            <div style={{ height: 300, overflow: "auto" }}>
              <ListGroup style={{ maxHeight: 20 }}>
                {this.state.heirarchy.map((cluster, idx) => {
                  return (
                    <ListGroup.Item
                      key={idx}
                      hidden={cluster.branchesByArea.length <= 0}
                      onClick={() => {
                        var data = this.state.heirarchy[idx];

                        this.isClusterSingleChecked(idx);
                        this.isAreaSingleChecked(
                          idx,
                          this.state.lastSelected.branchesByArea[0]
                        );

                        this.setState({
                          lastSelected: data,
                        });
                      }}
                    >
                      <span
                        className="float-right"
                        hidden={!this.getClusterCheckedState(idx)}
                      >
                        <img height={25} alt="selected" src={check} />
                      </span>
                      {cluster.clusterName}
                    </ListGroup.Item>
                  );
                })}
              </ListGroup>
            </div>
          </Col>
          <Col xl={8}>
            <div style={{ height: 300, overflow: "auto" }}>
              <ListGroup>
                {this.state.lastSelected.branchesByArea.map((area, idx) => {
                  return (
                    <ListGroup.Item
                      key={idx}
                      onClick={() => {
                        this.isAreaSingleChecked(idx, area);
                      }}
                    >
                      <span
                        className="float-right"
                        hidden={!this.getAreaCheckedState(idx)}
                      >
                        <img height={25} alt="selected" src={check} />
                      </span>
                      <span className="mr-1">{area.areaName}</span>
                      <span className="strong">
                        <Badge variant="danger">{area.areaCode}</Badge>
                      </span>
                    </ListGroup.Item>
                  );
                })}
              </ListGroup>
            </div>
            {/* <p>{this.getSelectedAreaCheckList()}</p> */}
          </Col>
        </Row>
      </Container>
    );
  };

  renderByBranch = () => {
    return (
      <div className="m-5" style={{ height: 300, overflow: "auto" }}>
        <h4>Branch Code</h4>
        <AsyncSelect
          isMulti={true}
          placeholder="Enter Branch Code"
          cacheOptions
          defaultOptions
          onChange={this.handlebranchCode}
          loadOptions={this.loadOptions}
        />
      </div>
    );
  };

  renderTabs = () => {
    return (
      <div
        style={{ maxheight: 200, overflow: "auto" }}
        className="shadow-sm p-3 rounded"
      >
        <Tabs
          activeKey={this.state.viewBy}
          onSelect={(k) => {
            this.setState({ viewBy: k });
            this.props.onSelectedByChanged(k);
          }}
        >
          <Tab eventKey="Cluster" title="By Cluster">
            {this.renderByCluster()}
          </Tab>
          <Tab eventKey="Area" title="By Area">
            {this.renderByArea()}
          </Tab>
          <Tab eventKey="Branch" title="By Branch">
            {this.renderByBranch()}
          </Tab>
        </Tabs>
      </div>
    );
  };

  render() {
    return this.state.isLoading === true ? (
      <Container style={{ maxheight: 200, overflow: "auto" }}>
        <CardLoader />
      </Container>
    ) : (
      <div>{this.renderTabs()}</div>
    );
  }

  premiseGetPeppHeirarchy = (data) => {
    return this.props.GetPeppHierarchy(data);
  };

  premiseGetMasterClusters = () => {
    return this.props.GetMasterClusters();
  };

  premiseGetMasterAreas = () => {
    return this.props.GetMasterAreas();
  };

  PremiseGetBranchByCode = (code) => {
    return this.props.GetBranchByCode(code);
  };
}

const mapStateToProps = (state) => {
  return {
    master_cluster: state.crdm.master_cluster,
    master_area: state.crdm.master_area,
    pepp_hierarchy: state.crdm.pepp_hierarchy,
  };
};

const mapDispatchToProps = {
  GetMasterClusters: GetMasterClusters,
  GetPeppHierarchy: GetPeppHierarchy,
  GetBranchByCode: GetBranchByCode,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PeppOperationSelector);
